import { Button } from "@mui/material";
import React from "react";

export default function BlueMediumButton({
  startIcon,
  buttonTitle,
  onClick,
  minWidth,
  endIcon,height
}) {
  return (
    <>
      <Button
        variant="contained"
        startIcon={startIcon ? startIcon : ""}
        onClick={onClick}
        endIcon={endIcon}
        sx={{
          borderRadius: "6px",
          fontSize: "14px",
          fontWeight: 600,
          textTransform: "none",
          backgroundColor: "#572575",
          minWidth: { minWidth },
          fontFamily:"Inter",
height: height?height:30,
          "&:hover": {
            backgroundColor: "#4A1E66",
          },
        }}
      >
        {buttonTitle}
      </Button>
    </>
  );
}
